import Modal from '@/common/components/Modal'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import useCancelMaintenanceWorkflowForwading from '../../Create/hooks/useCancelMaintenanceWorkflowForwading'
import { zodResolver } from '@hookform/resolvers/zod'
import TextArea from '@/common/components/TextArea'
import { maintenanceWorkflowForwardingCancelSchema, MaintenanceWorkflowForwardingCancelSchemaValidationSchema } from '../schema/forwardings/cancelMaintenanceWorflowForwarding.schema'

type CancelMaintenanceWorkflowForwadingModalProps =
  | {
      showTrigger: true
      isOpen?: boolean
      setIsOpen?: (isOpen: boolean) => void
      workflowForwadingId?: string
      workflowId?: string
    }
  | {
      showTrigger?: false
      isOpen: boolean
      setIsOpen: (isOpen: boolean) => void
      workflowForwadingId?: string
      workflowId?: string
    }

export const CancelMaintenanceWorkflowForwadingModal = (props: CancelMaintenanceWorkflowForwadingModalProps) => {
  const { workflowForwadingId, workflowId } = props
  const [internalIsOpen, setInternalIsOpen] = useState(false)

  const isOpen = props.showTrigger ? (props.isOpen ?? internalIsOpen) : props.isOpen
  const setIsOpen = props.showTrigger ? (props.setIsOpen ?? setInternalIsOpen) : props.setIsOpen
  const queryClient = useQueryClient()

  const { mutate: cancelMaintenanceWorkflowForwading } = useCancelMaintenanceWorkflowForwading({
    id: workflowForwadingId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding', workflowForwadingId] })
      queryClient.invalidateQueries({ queryKey: ['maintenanceWorkflow', workflowId] })
      reset()
      setIsOpen(false)
    },
    onError: (error) => FormTransformers.errorsTransformer({ setError })(error),
  })

  const {
    register,
    reset,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm<MaintenanceWorkflowForwardingCancelSchemaValidationSchema>({
    resolver: zodResolver(maintenanceWorkflowForwardingCancelSchema),
  });

  const onSubmit = (data: MaintenanceWorkflowForwardingCancelSchemaValidationSchema) => {
    cancelMaintenanceWorkflowForwading(data)
  }

  useEffect(reset, [isOpen])

  return (
    <Modal
      title="Cancelar encaminhamento do Processo de manutenção"
      subtitle={<p>Caso cancele, você perderá todo progresso feito, porém poderá criar outro posteriormente. <br /> Você tem certeza?</p>}
      subtitleClassName="mt-1 text-white-300"
      useCancellableFooter
      cancelButtonText='Voltar'
      confirmButtonText='Cancelar encaminhamento'
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={handleSubmit(onSubmit)}
      body={(
        <form className="flex flex-col gap-4">
          <TextArea
            className="text-white-800 opacity-80"
            label="Justificativa"
            {...register('cancel_reason')}
            errorMessage={errors.cancel_reason?.message || undefined}
            maxLength={512}
          />
        </form>
      )}
    />
  )
}
